import {endpoints} from '@kapitalist/contract/endpoints'
import type {
  TPathPiecesOf,
  TRequestOf,
  TResponseOf,
} from '@kapitalist/contract/endpoints/types'
import {PostApi} from '~/api/client'
import GetGameData from '~/api/endpoints/game/GetGameData'

const endpoint = endpoints.spectator.requestSpectatorPermission
type Params = TRequestOf<typeof endpoint>
type PathPieces = TPathPiecesOf<typeof endpoint>
type Response = TResponseOf<typeof endpoint>

/**
 * A spectator can ask a player to let them see their hand.
 */
export default class RequestSpectatorPermission extends PostApi<typeof endpoint>() {
  constructor() {
    super(endpoint)
  }

  protected getMockResponse(params: Params, pathPieces: PathPieces): Response {
    return GetGameData.mockResponseWithMockConfig({
      pathPieces: {
        ...pathPieces,
        maybeGameId: pathPieces.gameId,
      },
    })
  }

  protected getPath(pathPieces: PathPieces) {
    return endpoint.path(pathPieces)
  }

  protected transformResponse(r: Response) {
    return r
  }
}
